import { useSelector } from "react-redux";

// corresponds to user permission
const usePermission = (allowedPermissions = []) => {
  const { userDetails } = useSelector((state) => state.loggedInUser);

  if (userDetails?.permissions?.length) {
    const hasPermission = allowedPermissions?.some((item) =>
      userDetails.permissions.includes(item),
    );

    return hasPermission;
  }

  return false;
};

// check if the user is a songa tenant or no
export const useSongaTenant = () => {
  const { userDetails } = useSelector((state) => state.loggedInUser);
  return userDetails.isSongaMobilityUser;
};

// corresponds to tenant permission
export const useTenantPermission = (allowedPermissions = []) => {
  const { userDetails } = useSelector((state) => state.loggedInUser);

  if (userDetails?.tenantPermissions?.length) {
    const hasPermission = allowedPermissions?.some((item) =>
      userDetails.tenantPermissions.includes(item),
    );

    return hasPermission;
  }

  return false;
};

export default usePermission;
